module.exports = __webpack_public_path__ + "img/f3.1695dd2.png";